export default "__VITE_ASSET__CZz6Q00U__"